import { SalaryInquiry } from './salary/salaryinquiry';

export const FINANCE_INDEX = [
  SalaryInquiry
]


// WEBPACK FOOTER //
// ./src/pages/application/finance/index.ts